// extracted by mini-css-extract-plugin
module.exports = {"button":"style__button__5BkQX"};